import React, { useEffect, useState } from 'react';
import { TextField } from '@common-ui/ui';

export default function TextFieldWrapper({ id, initialValue, ...otherProps }) {
  const [value, setValue] = useState(initialValue ?? '');

  useEffect(() => {
    setValue(initialValue ?? '');
  }, [initialValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return <TextField id={id} value={value} onChange={handleChange} {...otherProps} />;
}
